webpackJsonp([28820886734699],{

/***/ 1265:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"NotificationType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"APPROVAL_REQUIRED_MEDICATION"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"LAB"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"RDVM_MARKETING"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"SCRIBE_COMPLETED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"TASK_ASSIGNED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"TASK_COMMENT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"TASK_COMPLETED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"TEXT_PAYMENT_RECEIVED"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-notification-type-e7bd3a24df7dd2239173.js